import React, { Component } from 'react';
import imgPlaceholder from '../../assets/img/img-placeholder.png';


class ImageUpload extends Component {

    onImageChoose = (e, setFieldValue) => {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            if (file.type.indexOf('image') === -1) {
                setFieldValue(this.props.name, 'not image');
            } else {
                setFieldValue(this.props.name, reader.result);
            }
        };
        reader.readAsDataURL(file);
    };

    render() {
        const { name, onChange, label, value, error } = this.props;
        const image = value && value.length !== 0 && value !== 'not image' ? value : imgPlaceholder;
        return (
            <div className="image-upload size-md my-20">
                <p className="color-grey50 font-sm w-700">{ label }</p>
                <div className="image mt-10">
                    <img src={ image } alt="placeholder"/>

                </div>
                <div className="upload-meta mt-10 text-field">
                    <label>
                        <input name={name} type="file" hidden onChange={(e) => this.onImageChoose(e, onChange)} />
                        { error ?  <span className="error-msg mb-10" >{ error }</span> : null }
                        <span style={{color: 'red'}}></span>
                        <p className="flex-align-y font-sm w-800">
                            <i className="fa fa-upload mr-10">
                            </i>{ value ? 'Change' : 'Choose'}
                            File
                        </p>
                    </label>
                </div>
            </div>
        );
    }
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/UI/ImageUpload-f.js